module.exports = __webpack_public_path__ + "static/media/budget.c199d158.png";